export default __webpack_public_path__ + "static/media/drop_down.ccddb7c8.svg";